/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteDocumentMutationResponse,
  DeleteDocumentPathParams,
  DeleteDocument404,
} from '../types/DeleteDocument'

function getDeleteDocumentUrl({ id }: { id: DeleteDocumentPathParams['id'] }) {
  const res = { method: 'DELETE', url: `/api/v1/documents/${id}/` as const }
  return res
}

/**
 * @description Delete a document.
 * Args:
 * request: DRF request
 * pk: Document UUID
 * Returns:
 * 204 No Content on success
 * 404 Not Found if document doesn't exist
 * 500 Internal Server Error on unexpected errors
 * @summary Delete a document
 * {@link /api/v1/documents/:id/}
 */
export async function deleteDocument(
  { id }: { id: DeleteDocumentPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteDocumentMutationResponse,
    ResponseErrorConfig<DeleteDocument404>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteDocumentUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
